import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRouteLayers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.4233 3.18303C11.769 2.93899 12.2309 2.93899 12.5767 3.18303L21.0767 9.18303C21.3421 9.37041 21.5 9.67508 21.5 10C21.5 10.3249 21.3421 10.6296 21.0767 10.817L12.5767 16.817C12.2309 17.061 11.769 17.061 11.4233 16.817L2.92331 10.817C2.65786 10.6296 2.49999 10.3249 2.49999 10C2.49999 9.67508 2.65786 9.37041 2.92331 9.18303L11.4233 3.18303ZM5.23405 10L12 14.776L18.7659 10L12 5.22404L5.23405 10Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.68302 13.4233C3.00152 12.9721 3.62548 12.8645 4.07667 13.183L12 18.776L19.9233 13.183C20.3745 12.8645 20.9985 12.9721 21.317 13.4233C21.6355 13.8745 21.5279 14.4985 21.0767 14.817L12.5767 20.817C12.2309 21.061 11.769 21.061 11.4233 20.817L2.92331 14.817C2.47211 14.4985 2.36453 13.8745 2.68302 13.4233Z",
		fill: "currentColor"
	})]
});
export default SvgRouteLayers;
